import React, { FC } from 'react';
import { Event } from '../../Interfaces/Event';
import styles from './Input.module.scss';

interface Props {
  list: any[],
  fieldName: string,
  // eslint-disable-next-line no-unused-vars
  onChange: (e: Event) => void,
}

const Dropdown: FC<Props> = ({ list, fieldName, onChange }) => (
  <select className={styles.input} name={fieldName} onChange={onChange}>
    {list.map(({ code, name }) => (<option value={name} key={code}>{name}</option>))}
  </select>
);

export default Dropdown;
